export default {
    CREATE_BOARD: () => '/board/createBoard',
    GETALLBOARD: (query) => `/board/getAllBoard?${query ? query : ''}`,
    SELECTED_BOARD: (id) => `/boardList/getBoardListByboardId/${id}`,
    SEQUENCE: (id) => `/boardList/updateBoardListSequence/${id}`,
    DELETE_BOARD: (id) => `/board/deleteBoard/${id}`,
    GET_BOARD_LIST: () => `/board/getBoardWithBoardList`,
    GET_BOARD_LIST_BY_ID: (id) => `/board/getBoardBy/${id}`,
    UPDATE_BOARD_BY_ID: (id) => `/board/updateBoard/${id}`
};
